import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { classNames } from '../EddFilesTable/EddFilesTable';
import ErrorTooltip from './ErrorTooltip';
import { DEFAULT_COL_WIDTH } from './csvTableUtils';

const CsvBodyRow = memo(function CsvBodyRow({ row, columnTitles, columnWidths, error }) {
  return (
    <>
      {columnTitles.map((title, colIndex) => (
        <div
          key={title}
          className="relative flex-shrink-0"
          style={{ width: columnWidths[title] || DEFAULT_COL_WIDTH }}
        >
          {colIndex === 0 && error && <ErrorTooltip error={error} />}
          <input
            onChange={() => {}}
            className={classNames(
              'w-full text-sm h-10 border outline-none text-center',
              colIndex === 0 && error ? 'bg-red-300' : '',
            )}
            value={row[title].value}
          />
        </div>
      ))}
    </>
  );
});

export default CsvBodyRow;

CsvBodyRow.propTypes = {
  row: PropTypes.object.isRequired,
  columnTitles: PropTypes.arrayOf(PropTypes.string).isRequired,
  columnWidths: PropTypes.object.isRequired,
  error: PropTypes.object,
};
